
import { formUploadCore } from './core';

/**
 * Collects the Adobe core and ehi-core Form Upload component clientlibs code to create a full cheerio.
 * @type {Object}
 */
export const formUploadCheerio = {
	/**
	 * init method to trigger running of the full cheerio code
	 * @return {void}
	 */
  init() {
    formUploadCore.init();
  }
};

